import React from 'react';

const Image_gif = ({ text }) => {
  return (
    <img
      src={`assets/img/${text}.gif`}
      alt={text}
      loading="lazy"
    />
  );
};

export default Image_gif;
